import { getUserAgent } from '@yembo/yemblocks-core/dist/_util';
import browserLocale from 'browser-locale';

export const snapshotDebugInfo = () => {
  const { os, browser } = getUserAgent();
  const locale = browserLocale();

  const windowRecord = window as unknown as Record<string, unknown>;

  windowRecord.osInfo = { name: os.name, version: os.version };
  windowRecord.browserInfo = { name: browser.name, version: browser.version };
  windowRecord.resolution = `${window.screen.width * window.devicePixelRatio} x ${
    window.screen.height * window.devicePixelRatio
  }`;
  windowRecord.ramInfo = navigator.deviceMemory ? `At least ${navigator.deviceMemory} GB of RAM` : 'Unknown';
  windowRecord.locale = locale;
};
